import { useState } from "react";
import { Lock } from "lucide-react";
import { adminApi } from "../../pages/Segreteria";
import { inputCls, labelCls } from "../legend/ContactForm";

const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Accesso non riuscito. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
};

export const AdminLogin = ({ onLogin }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await adminApi.post("/auth/login", form);
      onLogin(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <form
        data-testid="admin-login-form"
        onSubmit={onSubmit}
        className="w-full max-w-md bg-neutral-900 border border-neutral-800 border-t-4 border-t-red-600 p-8 space-y-5"
      >
        <div className="flex items-start gap-4">
          <span className="w-12 h-12 shrink-0 bg-red-600 flex items-center justify-center">
            <Lock className="w-6 h-6 text-white" />
          </span>
          <div>
            <div className="mono-label text-xs text-red-500 uppercase tracking-wider">Accesso riservato</div>
            <h1 className="font-display text-2xl font-black uppercase text-white">Segreteria Legend Team</h1>
            <p className="text-xs text-neutral-400 mt-1">Richieste dal sito, tesseramenti e documenti dei soci.</p>
          </div>
        </div>
        <div>
          <label htmlFor="admin-email" className={labelCls}>Email</label>
          <input id="admin-email" type="email" data-testid="admin-email-input" className={inputCls} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoComplete="username" />
        </div>
        <div>
          <label htmlFor="admin-password" className={labelCls}>Password</label>
          <input id="admin-password" type="password" data-testid="admin-password-input" className={inputCls} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required autoComplete="current-password" />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="text-xs text-red-400 border border-red-900 bg-red-950/40 p-3">{error}</p>
        )}
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="w-full px-8 py-3 bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-black uppercase text-xs tracking-widest transition-colors"
        >
          {loading ? "Accesso..." : "Entra"}
        </button>
      </form>
    </div>
  );
};
